import React, { memo, useMemo } from "react";
import { Link } from "react-router-dom";

import { Card } from "react-bootstrap";
import { Skeleton } from "@mui/material";

import { ROUTE_SIM } from "../../../routes";

import {
  StyledCard,
  StyledSkeleton,
  StyledCardImg,
  SimCardLabel,
  CardScoreDiv,
  StyledRating,
} from "./styledSingleSimCard";

const SingleSimCardComponent = ({ $Carousel, data, isIframe, className }) => {
  const CardLabelString = () => {
    if (data.is_free) return "رایگان";
    if (data.is_subscribed) return "آزمایش من";
    return;
  };

  const CardLabel = useMemo(() => CardLabelString(), [data.is_free]);

  return !data ? (
    <span className={className}>
      <StyledCard className="mx-auto border-0" $Carousel={$Carousel}>
        <StyledSkeleton variant="rectangular" height={200} />
        <Skeleton className="mx-2" />
        <Skeleton width="50%" className="mx-2" />
        <Skeleton width="75%" className="mb-2 mx-2" />
      </StyledCard>
    </span>
  ) : (
    <Link
      to={
        isIframe
          ? `${ROUTE_SIM}${data.id}?view-port=iframe`
          : `${ROUTE_SIM}${data.id}`
      }
      className={className}
    >
      <StyledCard className="mx-auto border-0" $Carousel={$Carousel}>
        <StyledCardImg src={data.image} height="180" width="360" alt={data.name} />
        {CardLabel && <SimCardLabel>{CardLabel}</SimCardLabel>}
        <Card.Body>
          <CardScoreDiv className="d-flex justify-content-end">
            <span>({data.count_score} رای)</span>
            <b className="text-muted">
              {data.score % 10 !== 0 ? data.score.toFixed(2) : data.score}
            </b>
            <StyledRating
              dir="ltr"
              name="lab-score"
              value={data.score}
              readOnly
              precision={0.25}
            />
          </CardScoreDiv>
          <h5 className="mb-0">{data.name}</h5>
          <p className="mb-0">
            {$Carousel && data.topic.length > 50
              ? `${data.topic.slice(0, 50)}...`
              : data.topic}
          </p>
        </Card.Body>
      </StyledCard>
    </Link>
  );
};

export default memo(SingleSimCardComponent);
